import { FieldArrayRenderProps } from "formik";
import React, { ReactNode } from "react";
import { Button, Icon } from "../";
export interface DraggableRowDeleteProps {
	arrayHelpers: FieldArrayRenderProps;
	index: number;
	children?: ReactNode;
}

export const DraggableRowDelete: React.FC<DraggableRowDeleteProps> = ({ children, arrayHelpers, index }) => {
	return (
		<Button
			purpose="plain"
			classes="btn-sm btn-square"
			onClick={(evt) => {
				evt.preventDefault();
				evt.stopPropagation();
				arrayHelpers.remove(index);
			}}
		>
			<Icon icon="trash-alt" classes="fa-fw" />
		</Button>
	);
};
